import { useEffect } from 'react';
import UploadAssets from './UploadAssets'
import { useDispatch, useSelector } from 'react-redux';
import { base64ToArrayBuffer, saveByteArray } from 'utils';
import { setTemplateData, downloadTemplate } from 'Store/AssetInventory/MandAScan/MandAScanAction';

const UploadAssetsContainer = (props: any) => {
  const { 
    values: {scanName, uploadAssetsError}, 
    list, handleFileChange, 
    removeUploadedFile,
    isAssetsUploaded 
    } = props
 
  const dispatch = useDispatch()


  const {
    template
  }: any = useSelector((state: any) => ({
    template: state.mergerAndAquisitionReducer.template,
  }))

  useEffect(() => {
    if (template) {
      const byteArray = base64ToArrayBuffer(template)
      saveByteArray('MA_Acquisition_Upload_Template', byteArray, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
    }

    return () => {
      dispatch(setTemplateData(''))
    }
  }, [template])





  const onDownloadTemplateClick = () => {
    dispatch(setTemplateData(''))
    dispatch(downloadTemplate())
  }

  return (
    <UploadAssets
      scanName={scanName}
      handleFileChange={handleFileChange}
      list={list}
      onDownloadTemplateClick={onDownloadTemplateClick}
      removeUploadedFile={removeUploadedFile}
      uploadAssetsError={uploadAssetsError}
      isAssetsUploaded={isAssetsUploaded}
    />
  )
}

export default UploadAssetsContainer